<div class="container-fluid">
  <div class="card">
    <div class="card-header nocollapse">
      Multiple Choice Type Question
    </div>
    <div [hidden]="folderId == -1">
      <div class="bg-info p-1 mb-3">
        <div class="row">
          <div class="col-md-10">
            <span class="text-white pt-2" style="font-size:18px; display:inline-block"><b>Folder Name : </b>{{ folderName }}</span>
          </div>
          <div class="col-md-2 py-1">
            <button type="button" class="btn btn-primary btn-action" (click)="backToSectionUrl()" [hidden]="redirectedSectionId==null || redirectedSurveyId==null"><i class="fa fa-arrow-left"></i> Back to Section</button>
            <button type="button" class="btn btn-primary btn-action mb-0" (click)="backUrl()"><i class="fa fa-home"></i> Home</button>
          </div>
        </div>
      </div>
    </div>

    <div id="messageContainer" class="card-header nocollapse bg-info col-md-12 msg-container" style="display:none;">
      <i class="fa fa-info-circle fa-lg mt-1" style="color: #326295;"></i>
      <span id="message"></span>
    </div>
    <div class="card-body">
      <form [formGroup]="choiceForm" class="col-md-12">
        <accordion class="nav-item dropdown p-2">
          <accordion-group [isOpen]="isQuestionTitleOpen">
            <span accordion-heading>
              <div style="display: flex; justify-content: space-between; align-items: center; width: 100%">
                <span>Question Title</span>
                <span style="cursor:pointer" (click)="isQuestionTitleOpen = true; isOptionsConfigOpen = false; $event.stopPropagation()">
                  <i class="fa" [ngClass]="{'fa-chevron-down': isQuestionTitleOpen, 'fa-chevron-right': !isQuestionTitleOpen}"></i>
                </span>
              </div>
            </span>
            <div class="col-md-12 card-body p-1">
              <div class="row mb-3">
                <label data-required for="description" class="form-control-label col-md-2">Title</label>
                <div class="col-md-10">
                  <textarea class="form-control" style="width:100%" rows="4" id="description" name="description" formControlName="description" placeholder="Type Question" #description></textarea>
                </div>
              </div>

              <div class="row mb-3">
                <label class="form-control-label col-md-2" for="questionCategoryId">Category</label>
                <div class="col-md-3">
                  <select name="questionCategoryId" id="questionCategoryId" formControlName="questionCategoryId" class="form-control">
                    <option value="" selected>--Select--</option>
                    <option *ngFor="let item of questionCategoryList" [ngValue]="item?.questionCategoryId" [selected]="questionCategoryId==item?.questionCategoryId">
                      {{item.questionCategoryName}}
                    </option>
                  </select>
                </div>
                <div class="col-md-auto">
                  <button type="button" class="btn btn-primary btn-action" (click)="openCategoryModal()">
                    <i class="fa fa-plus"></i> Create Category
                  </button>
                </div>
                <label class="form-control-label col-md-auto px-3" for="shortName">Short Name</label>
                <div class="col-md-3">
                  <input class="form-control" maxlength="30" type="text" id="shortName" name="shortName" formControlName="shortName" placeholder="Short Name" />
                </div>
              </div>

             
              <div class="row">
                <div class="col-md-12 d-flex justify-content-end">
                  <button (click)="saveQuestion()" type="button" class="btn btn-primary btn-action pull-right" [disabled]="!choiceForm.valid"><i class="fa fa-plus"></i> Create / Update</button>
                  <button type="button" class="btn btn-secondary btn-action pull-right" (click)="resetQuestion()"><i class="fa fa-eraser"></i> Clear</button>
                </div>
              </div>
            </div>
          </accordion-group>

          <accordion-group [isOpen]="isOptionsConfigOpen">
            <span accordion-heading>
              <div style="display: flex; justify-content: space-between; align-items: center; width: 100%">
                <span>Choice Configuration</span>
                <span style="cursor:pointer" (click)="isOptionsConfigOpen = true; isQuestionTitleOpen = false; $event.stopPropagation()">
                  <i class="fa" [ngClass]="{'fa-chevron-down': isOptionsConfigOpen, 'fa-chevron-right': !isOptionsConfigOpen}"></i>
                </span>
              </div>
            </span>
            <div class="row mb-3">
              <div class="col-md-4 d-flex gap-3">
                <button type="button" class="btn btn-secondary btn-action" (click)="resetForm()"><i class="fa fa-eraser"></i> Clear</button>
                <button (click)="addChoice()" type="button" class="btn btn-primary btn-action" [disabled]="this.questionId===0"><i class="fa fa-plus"></i> Create / Update</button>
                <button type="button" class="btn btn-primary btn-action" (click)="arrangeOrder()"><i class="fa fa-reorder"></i>Update Order</button>
              </div>
            </div>
            <div class="row px-2 mb-3">
              <label class="col-md-2 form-control-label ps-0" for="questionOption">&nbsp;Option Name</label>
              <div class="col-md-2"><input class="form-control" maxlength="1000" type="text" id="questionOption" name="questionOption" formControlName="questionOption" placeholder="Option" /></div>
              <label class="col-md-2 form-control-label" for="weightage">Weightage</label>
              <div class="col-md-2"><input class="form-control" maxlength="10" type="text" id="weightage" name="weightage" formControlName="weightage" placeholder="Weightage" /></div>
              <label class="col-md-2 form-control-label" for="optionShortName">Short Name</label>
              <div class="col-md-2"><input class="form-control" maxlength="100" type="text" id="optionShortName" name="optionShortName" formControlName="optionShortName" placeholder="Short Name" /></div>
            </div>
           
            <div class="row px-2 mb-3">
              <label class="col-md-2 form-control-label" for="hoverText">Hover Text</label>
              <div class="col-md-2"><textarea class="form-control" style="width:100%" rows="2" id="hoverText" name="hoverText" formControlName="hoverText" placeholder="Hover Text" #hoverText></textarea></div>
              <div class="col-md-2 d-flex align-items-center gap-2">
                <input class="form-check mt-1" type="checkbox" id="isTextboxRequired" name="isTextboxRequired" formControlName="isTextboxRequired" placeholder="isTextboxRequired" /> <label class="form-control-label ps-2" for="isTextboxRequired">Is textbox required?</label>
              </div>
              <div class="col-md-2 d-flex align-items-center gap-2">
                <input class="form-check mt-1" type="checkbox" id="evaluateAndExit" name="evaluateAndExit" formControlName="evaluateAndExit" placeholder="evaluateAndExit" /> <label class="form-control-label ps-2" for="evaluateAndExit">Evaluate and exit</label>
              </div>
            </div>
            <br />
            <div class="overflow-auto" style="max-height:200px">
              <isg-grid [rowData]="questionOptionList"
                        [columnDefs]="columnDefs"
                        [config]="optionGridConfig"
                        (gridReady)="onQuestionGridReady($event)">
              </isg-grid>
            </div>
          </accordion-group>
        </accordion>
      </form>
    </div>
  </div>

  <ng-template #deleteOptionConfirmation let-modal>
    <div class="modal-header">
      <h5 class="modal-title">Delete Choice Confirmation</h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
      <div class="form-control-label">
        Are you sure you want to delete the selected choice?
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" (click)="deleteOptions(); modal.close()" class="btn btn-danger btn-modal"><i class="fa fa-trash"></i> Delete</button>
      <button type="button" class="btn btn-secondary btn-modal" (click)="modal.dismiss()"><i class="fa fa-times"></i> Close</button>
    </div>
  </ng-template>

</div>

<ng-template #CreateCategoryModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title"> Create Category</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="ResetQuesCategoryForm(); modal.dismiss()"></button>
  </div>

  <div class="modal-body">
    <form [formGroup]="quesCategoryForm" #f="ngForm">
      <div class="row align-items-center">
        <label data-required class="col-md-4 form-control-label" for="quesCategoryName">Category</label>
        <div class="col-md-8">
          <input class="form-control" type="text" id="quesCategoryName" name="quesCategoryName" formControlName="quesCategoryName" placeholder="Category" />
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-modal" (click)="ResetQuesCategoryForm(); modal.dismiss()"><i class="fa fa-times"></i> Close</button>
    <button type="button" class="btn btn-primary btn-modal" [disabled]="!quesCategoryForm.valid" (click)="AddQuesCategory(); modal.close()"><i class="fa fa-save"></i> Save</button>
  </div>
</ng-template>
